import React from 'react'

import s from './styles.module.scss'

import { Loader } from '..'
import DetectReachBottom, {
  IDetectReachBottomProps,
} from '../../atoms/detect-reach-bottom/DetectReachBottom'

export interface IDetectReachBottomWithLoaderProps
  extends IDetectReachBottomProps {
  showLoader: boolean
}

const DetectReachBottomWithLoader = ({
  onReachBottom,
  showLoader,
}: IDetectReachBottomWithLoaderProps) => {
  return (
    <>
      <DetectReachBottom onReachBottom={onReachBottom} />
      {showLoader && (
        <div className={s.loadMore}>
          <Loader size={30} />
        </div>
      )}
    </>
  )
}

export default DetectReachBottomWithLoader
